import {Head, Link} from '@inertiajs/react';
import {PageProps} from '@/types';
import LandingPageHeader from "@/Pages/Landing/Partials/LandingPageHeader";
import HowItWorks, {HowItWorksProps} from "@/Pages/Landing/Partials/HowItWorks";
import GuestLayout from "@/Layouts/Guest/GuestLayout";
import useTranslations from '@/hooks/useTranslations';

export default function HardcodedSubtitles({}: PageProps) {
    const { __ } = useTranslations();

    const steps = __('generate-subtitles.steps');
    const howToSteps: {title: string, description: string}[] = __('generate-subtitles.how_to.steps');
    return (
        <GuestLayout>
            <Head title={__('generate-subtitles.title')}>
                <title>{__('generate-subtitles.title')}</title>
                <meta name="description"
                      content={__('generate-subtitles.meta_description')}/>
            </Head>
            <LandingPageHeader
                buttonText={__('generate-subtitles.header.button_text')}
                title={__('generate-subtitles.header.title')}
                description={__('generate-subtitles.header.description')}
            />
            <div className="py-10"></div>
            <HowItWorks steps={steps} title={__('generate-subtitles.steps_title')}/>
            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row items-center justify-center space-x-4">

                    <div className="md:mr-10 lg:mr-40 flex-shrink-0">
                        <img alt={__('generate-subtitles.image_alts.method_selection')}
                             className="object-contain md:w-[550px] shadow-md border-gray-300"
                             src="/img/select-method-screenshot.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('generate-subtitles.features.multiple_methods.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('generate-subtitles.features.multiple_methods.description')}</p>
                    </div>
                </div>
            </div>
            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row-reverse items-center justify-center space-x-4 ">

                    <div className="md:mr-10 lg:ml-40 flex-shrink-0">
                        <img alt={__('generate-subtitles.image_alts.subtitle_detection')}
                             className="object-contain md:w-[550px] rounded-lg "
                             src="/img/detecting-subtitle-in-video.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('generate-subtitles.features.caption_detection.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('generate-subtitles.features.caption_detection.description')}</p>
                    </div>
                </div>
            </div>

            <div className="py-6"></div>
            <div className="w-full lg:max-w-screen-xl mx-auto px-5">
                <div className="flex flex-col md:flex-row items-center justify-center space-x-4">

                    <div className="md:mr-10 lg:mr-40 flex-shrink-0">
                        <img alt={__('generate-subtitles.image_alts.generation_files')}
                             className="object-contain md:w-[550px] shadow-md border-gray-300"
                             src="/img/subtitle-extraction-files.png"/>
                    </div>


                    <div className="text-center md:text-start mt-5 md:mt-0">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-4">{__('generate-subtitles.features.fast_generation.title')}</h2>
                        <p className="text-gray-600 dark:text-gray-400">{__('generate-subtitles.features.fast_generation.description')}</p>
                    </div>
                </div>
            </div>


            <section className="bg-gray-50 dark:bg-gray-800 py-14 my-10">
                <div className="lg:max-w-screen-xl mx-auto">
                    <div className="p-4 sm:p-8  bg-white dark:bg-gray-900 shadow sm:rounded-lg">
                        <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-8">{__('generate-subtitles.how_to.title')}</h2>
                        <ol className="list-decimal list-inside space-y-4">
                            {
                                howToSteps.map((step, index) => (
                                    <li key={index} className="text-gray-900 dark:text-gray-100">
                                        <strong className="font-bold text-gray-900 dark:text-gray-100">{step.title}</strong>
                                        <p className="text-gray-700 dark:text-gray-300">{step.description}</p>
                                    </li>
                                ))
                            }
                        </ol>
                    </div>
                </div>
            </section>
            <div className="flex flex-col items-center justify-center space-y-4">
                <Link
                    href={route('register')}
                >
                    <button
                        className="rounded text-lg  w-fit transition focus-visible:ring-2 ring-offset-2 ring-gray-200 px-5 py-2.5  hover:bg-gray-500 hover:text-white  border-2 border-gray-500 inline-flex  gap-1 items-center ">
                        {__('generate-subtitles.cta.get_started')}
                    </button>
                </Link>
            </div>
        </GuestLayout>
    );
}
